import React from 'react';

export default function PlayIcongc() {
  return (
    <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m9 7 14 9-14 9V7Z" fill="#fff" />
    </svg>
  );
}
